export default class Quiz {
	constructor() {
		this.quiz = document.querySelector('[data-quiz]');

		if (!this.quiz) {
			return;
		}

		this.fieldwrapper = document.querySelector('.gform_fields');
		this.allFields = document.querySelectorAll('.gfield');
		this.sections = this.fieldwrapper.querySelectorAll('.gsection');
		this.questions = this.fieldwrapper.querySelectorAll('.gquiz-field');
		this.submitBtn = this.quiz.querySelector('input[type="submit"]');

		this.questions.forEach((element) => {
			element.addEventListener('change', this.answerQuestion.bind(this));
		});

		this.init();
	}

	init() {
		this.questions.forEach((element, index) => {
			element.setAttribute('data-index', index);

			if (index == 0) {
				return;
			}

			element.classList.add('is-disabled');
		});

		this.sections.forEach((element, index) => {
			element.setAttribute('data-index', index);
			if (index == 0) {
				element.classList.add('is-current');
				return;
			}
			element.classList.add('is-disabled');
		});

		this.submitBtn.disabled = true;

		this.checkState();
	}

	checkState() {
		this.questions.forEach((element, index) => {
			const inputs = element.querySelectorAll('input');
			inputs.forEach((input) => {
				if (input.checked) {
					element.dispatchEvent(new Event('change'));
				}
			});
		});
	}

	answerQuestion(e) {
		const currentIndex = e.currentTarget.getAttribute('data-index');
		this.sections[currentIndex].classList.add('is-answered');
		this.sections[currentIndex].classList.remove('is-current');

		if (currentIndex == this.sections.length - 1) {
			this.submitBtn.disabled = false;
			return;
		}

		const nextIndex = e.currentTarget.nextSibling.getAttribute('data-index');
		this.sections[nextIndex].classList.remove('is-disabled');
		this.sections[nextIndex].classList.add('is-current');
		this.questions[nextIndex].classList.remove('is-disabled');
	}
}
